export default function Shortcode1789305925359() {
  return <section data-section-id="Shortcode1789305925359" id="mailpoet-form-content" className="container mx-auto px-[2px]"></section>;
}